import React from 'react';

const Blog = () => {
  return (
    <h1>
        TBD
    </h1>
  );
};

export default Blog;
